import { Component, OnInit, Inject, OnDestroy, ViewChild, AfterViewInit, ViewChildren, QueryList } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthenticationService } from "@app/shared/services/authentication.service";
import { DataService } from "@app/feature/main/roles-shared/services/data.service";
import { RolesSharedService } from "@app/feature/main/roles-shared/services/roles-shared.service";
import { MarketDataChartGeneratorService } from "@app/feature/main/roles-shared/services/market-data-chart-generator.service";
import swal from "sweetalert2";
import { CheckoutModalComponent } from "@app/feature/main/roles-shared/components/checkout-modal/checkout-modal.component";
import { MarketDataDetailsService } from "@app/feature/main/roles-shared/services/market-data-details.service";
import { NickNameModalService } from "@app/feature/main/roles-shared/services/nick-name-modal.service";
import { CommentModalService } from "@app/shared/services/comment-modal.service";
import { BreadcrumService } from "@app/shared/services/breadcrum.service";
import { ChartComponent } from '@app/feature/main/roles-shared/components/chart/chart.component';
import { LinkShareComponent } from '@app/shared/components/link-share/link-share.component';
import { SocialShare } from '@app/shared/services/social-share.service';
import { LikeModalServiceService } from "@app/shared/services/like-modal-service.service";
import { MixpanelEventLoggingService } from "@app/shared/services/mixpanel-event-logging.service";
import { CompanyDetailsComponent } from './../../../tech-buyer/company-details/company-details.component';
// import { _ } from "core-js";
import * as _ from 'lodash';
import { Title } from "@angular/platform-browser";
import { TechBuyerService } from "@app/feature/main/tech-buyer/shared/services/tech-buyer.service";

declare var window: any;

declare var $: any;
@Component({
  selector: "app-research-snapshot",
  templateUrl: "./research-snapshot.component.html",
  styleUrls: ["./research-snapshot.component.css"]
})
export class ResearchSnapshotComponent implements OnInit, OnDestroy{
  @ViewChild(CheckoutModalComponent) checkoutModalDetails: CheckoutModalComponent;
  @ViewChild(CompanyDetailsComponent) companyDetails: CompanyDetailsComponent;

  userRole;
  loggedInStatus;
  resHighlightData = [1, 2];
  paramObj;
  researchId;
  entityType: string;
  researchData: any = { ratings: 0 };
  surveyParticipatedStatus;
  surveyId;
  marketData: any;
  userDetailsObject: any;
  userId: any;
  viewindex: any;
  currentBookmarkId: string = null;
  @ViewChildren(ChartComponent) chartChildren: QueryList<ChartComponent>;
  @ViewChild(LinkShareComponent) linkShare: LinkShareComponent;
  chartChildrenArray: ChartComponent[];
  downloadHide: any;
  hasCompanyDetails = false;

  constructor(
    private authenticationService: AuthenticationService,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private route: ActivatedRoute,
    private dataService: DataService,
    private rolesSharedService: RolesSharedService,
    private breadcrumService:BreadcrumService,
    public marketDataChartGenerator: MarketDataChartGeneratorService,
    private marketDataDetailsService: MarketDataDetailsService,
    private nickNameModalService: NickNameModalService,
    private commentModalService: CommentModalService,
    private likeModalService: LikeModalServiceService,
    private socialShareService: SocialShare,
    private mixpanelEventLoggingService: MixpanelEventLoggingService,
    private titleService: Title,
    private techBuyerService: TechBuyerService,
  ) {
    this.document.body.classList.add("inner-page");
    this.document.body.classList.remove("outer-page");
    //window.scroll(0, 0);
  }

  ngOnInit() {   
    this.researchId = this.route.snapshot.paramMap.get("id");
    this.entityType = "research";

    this.userDetails();
    this.isLoggedIn();
    this.getResearchData(this.researchId);
     
    if (this.userRole === 'tech-vendor') {
      this.breadcrumService.setUrl('BC3Url', `${this.userRole}/market-data/${this.route.snapshot.params.id}`)
    } else {
      this.breadcrumService.setUrl('BC3Url', `${this.userRole}/research-snapshot/${this.route.snapshot.params.id}`)
    }
  }
  showModal() {
    if(window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null"){
      const userDetails = JSON.parse(window.sessionStorage.getItem("userDetails"));
      this.dataService.researchDocumentDataService(this.researchData);
      sessionStorage.setItem("currentSurveyId",this.researchData.surveyId);
      sessionStorage.setItem("researchDocumentId",this.researchData.id);
      console.log('The research module data', this.researchId, this.researchData.id)
      console.log('The company details', userDetails)
      if ( userDetails && userDetails.organization == null && this.userRole === "tech-buyer") {
        $("#company-details").modal("show");
        this.companyDetails.initializeModal();
       }else{
        this.dataService.researchDocumentDataService(this.researchData);
        sessionStorage.setItem("currentSurveyId",this.researchData.surveyId);
        sessionStorage.setItem("researchDocumentId",this.researchData.id);
        this.router.navigate([`tech-buyer/survey/${this.researchId}`]);
   
        this.titleService.setTitle('Survey Started: ' + this.researchData.title || 'Ecosystm');
        var _hsq = window._hsq = window._hsq || [];
         _hsq.push(["trackEvent", {
          id: this.researchData.title,
          value : this.researchData.title
          }]); 
        _hsq.push(['trackPageView'])
        _hsq.push(['refreshPageHandlers']);
       }
    }
  }
  refresh(evt: any) {
    // company details event
   this.getTechBuyerDetails();
    $("#company-details").modal("hide");
  }

  ngOnDestroy() {
    sessionStorage.setItem("isPrimeCall",'true');
    window.scroll(0,0);
  }

  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.userId = this.userDetailsObject.userId;
    }
  }
  close() {
    $("#company-details").modal("hide");
  }
 
  getTechBuyerDetails() {
    this.techBuyerService
      .getTechBuyerDetails(this.userId)
      .subscribe((response: any) => {

        const modifiedUserDetails = Object.assign(
          JSON.parse(window.sessionStorage.getItem("userDetails")),
          { organization: response.organization },
          { techBuyerOrganization: response.techbuyerOrganization }
        );
        window.sessionStorage.setItem(
          "userDetails",
          JSON.stringify(modifiedUserDetails)
        );
        if (window.localStorage.getItem("rememberMeStatus")) {
          if (window.localStorage.getItem("rememberMeStatus") === "true") {

            window.localStorage.setItem(
              "userDetails",
              JSON.stringify(modifiedUserDetails)
            );
          }
        }
        this.checkDetails();
      });
  }


  checkDetails() {
    if(window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null"){
      const userDetails = JSON.parse(window.sessionStorage.getItem("userDetails"));
      if ( userDetails && userDetails.organization) {
        this.hasCompanyDetails = true;
      } else {
        this.hasCompanyDetails = false;
      }
    }
  }

  navigateAllresearchPage() {
    if (this.userRole === 'tech-vendor') {
      this.router.navigate([`${this.userRole}/all-market-data`]);
    } else {
      this.router.navigate([`${this.userRole}/research/all-research`]);
    }
  }
  navigateTrendingResearchPage() {
    this.router.navigate([`${this.userRole}/research/trending-research`]);
  }
  getResearchData(researchDataId: any) {
    this.downloadHide = localStorage.setItem('download', JSON.parse('false'));
    const filter: any = {};
    filter.filter = JSON.stringify({
      include: [
        { survey: { responses: "users" } },
        "domain",
        { likes: "user" },
        { comments: "user" },
        { ratings: "user" },
        { bookmark: "user" },
        "geographies",
        "countries",
        "trendingResearch"
      ]
    });
    filter.isHighlight = "true";
    this.rolesSharedService.getResearchData(filter, researchDataId).subscribe(
      (researchData: any) => {
        if(researchData.title=='IBM AP Brand Health Research'){
          this.downloadHide = localStorage.setItem("download", JSON.parse('true'));
        }
        this.researchData = researchData;
        let researchHighlightsfilter: any = {}; // filter to get market data highlights of research docuent
        researchHighlightsfilter.researchDocumentId = this.researchData.id;
        researchHighlightsfilter.isHighlight = true;
        this.checkAlreadyPaid();

        this.titleService.setTitle('Research: ' + researchData.title || 'Ecosystm');
        var _hsq = window._hsq = window._hsq || [];
         _hsq.push(["trackEvent", {
          id: researchData.title,
          value : researchData.title
          }]); 
        _hsq.push(['trackPageView'])
        _hsq.push(['refreshPageHandlers']);



        this.rolesSharedService.getMarketDat(researchHighlightsfilter).subscribe((marketData: any) => {
          _.forEach(marketData, (marketData) => {
            marketData['marketData'] = {
              alphabeticalSorting: marketData.alphabeticalSorting,
              marketData: marketData.marketData,
              bookmarkId : marketData.bookmarkId,
              authorUserId : marketData.authorUserId,
              bookmarked : marketData.bookmarked,
              category : marketData.category,
              categoryId : marketData.categoryId,
              choiceOrder : marketData.choiceOrder,
              choices : marketData.choices,
              comments : marketData.comments,
              content : marketData.content,
              createdAt : marketData.createdAt,
              customQuestionFilters : marketData.customQuestionFilters,
              customUserProfileFilters : marketData.customUserProfileFilters,
              description : marketData.description,
              graphType : marketData.graphType,
              graphTypeId : marketData.graphTypeId,
              hasSolutionFilter : marketData.hasSolutionFilter,
              id : marketData.id,
              isActive : marketData.isActive,
              isClustered : marketData.isClustered,
              isDualAxisQuestion: marketData.isDualAxisQuestion,
              isParentQuestionGraph : marketData.isParentQuestionGraph,
              labels : marketData.labels,
              liked : marketData.liked,
              likes : marketData.likes,
              methodOfOperation : marketData.methodOfOperation,
              numberOfResponse : marketData.numberOfResponse,
              questionType : marketData.questionType,
              ratings : marketData.ratings,
              requiredChoices : marketData.requiredChoices,
              scale : marketData.scale,
              sortingOrder : marketData.sortingOrder,
              subCategoryId : marketData.subCategoryId,
              timeline : marketData.timeline,
              title : marketData.title,
              updatedAt : marketData.updatedAt,
              userBenchmark : marketData.userBenchmark,
              userFilters : marketData.userFilters,
              userProfileDataChoices : marketData.userProfileDataChoices,
              viableCount : marketData.viableCount,
              solutionQuestionFilterConfiguration: marketData.solutionQuestionFilterConfiguration,
              xAxischoices: marketData.xAxischoices

            };
          });

          this.marketData = marketData;
          if (marketData.length > 0) {
            marketData.forEach((element, i) => {
              this.marketDataChartGenerator.generateChartJSON(marketData[i].marketData).subscribe((chartJSON: any) => {
                this.marketData[i].ChartJSON = chartJSON;
              })
            });
          } else {
            this.marketData = null
          }
        }, (error) => {
        });

        setTimeout(() => {

        }, 1000);

      },
      error => {
        if (error.error.error.message == "You are not Subscribed for this research document") {
          swal({
            position: "center",
            type: "info",
            title: "You are not subscribed",
            showConfirmButton: false,
            timer: 2000
            // text: "Bookmarked"
          });
          setTimeout(() => {
            this.subscriptionRoute(this.researchData.techDomainId);
          }, 2000);
        }
      }
    );
  }

  isLoggedIn() {
    if (this.authenticationService.isLoggedIn()) {
      this.loggedInStatus = true;
      this.getRole();
    } else {
      this.loggedInStatus = false;
    }
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }

  likeClick(postData: any, type: string) {
    // like button click
    if (this.loggedInStatus) {
      if (this.userDetailsObject.nickName) {
        const dataBody = {
          postId: postData.id,
          postType: type,
          userId: this.userId
        };
        this.rolesSharedService.addLike(dataBody).subscribe(likeResponse => {
          postData.isLiked = likeResponse["liked"];
          if (likeResponse["liked"]) {
            // case when user is liked and updated in server
            postData.liked = true;
            postData.likes += 1;
            this.rolesSharedService.logLikeInMixpanel(dataBody.postType, postData.title);
          } else if (!likeResponse["liked"]) {
            // case when user is not liked and updated in server
            postData.liked = false;
            if (postData.likes !== 0) {
              postData.likes -= 1;
            }
          }
        })
      } else {
        this.nickNameModalService.openNickNameModal();
        this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
          if (response) {
            this.userDetails();
          }
        });
      }
    } else {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  openCommentModal(data , postType?) {
    let post: any;
    if (postType === 'market_data') {
      post = data.marketData;
      post.researchDocumentId = data.researchDocumentId;
    } else {
      post = data;
    }
    post.postType = postType;
    if(window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null"){
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      if (this.loggedInStatus && this.userDetailsObject.nickName) {
        this.commentModalService.modalStatus(true, post);
      } else {
        this.nickNameModalService.openNickNameModal();
      }
    }
  }

  populateComments(data , postType?) {
    let post: any;
    if (postType === 'market_data') {
      post = data.marketData;
      post.researchDocumentId = data.researchDocumentId;
    } else {
      post = data;
    }
    post.postType = postType;
    if (this.userDetailsObject.nickName) {
      data.showComments = !data.showComments;
    } else {
      this.nickNameModalService.openNickNameModal();
      this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
        if (response) {
          this.userDetails();
        }
      });
    }
  }


  bookmark(data: any, type: string) {
    const bookmarkData: any = {};
    bookmarkData.postId = data.id;
    bookmarkData.postType = type;
    if (data.bookmarkId && data.bookmarked) {
      bookmarkData.bookmarkId = data.bookmarkId;
    }
    if (type == "researchDocument") {
      bookmarkData.postId = data.id;
      bookmarkData.postType = type;
    }
    else {
      bookmarkData.postId = data.id;
      bookmarkData.postType = type;
      bookmarkData.researchDocumentId = this.researchData.id;
      bookmarkData.marketDataFilter = data.content;
    }
    this.rolesSharedService.bookmark(bookmarkData).subscribe(
      (response: any) => {
        this.getResearchData(this.researchId);
        if (response.bookmarked) {
          if (type == 'researchDocument') {
            this.researchData.bookmarked = true;
            this.mixpanelEventLoggingService.dispatchEvent("bookmark module", {
              "Tech Domain": this.researchData.domain ? this.researchData.domain.name : '' ,
              "Module Name": this.researchData ? this.researchData.title : ''
            });
          } else if (type == 'marketData') {
            data.bookmarked = true;
            this.mixpanelEventLoggingService.dispatchEvent("bookmark market data", {
              "Tech Domain": this.researchData.domain ? this.researchData.domain.name : '' ,
              "Market Data Title": data.title ? data.title : ''
            });
          }
          swal({
            position: "center",
            type: "success",
            title: "Added to the bookmarks list",
            showConfirmButton: false,
            timer: 1000
            // text: "Bookmarked"
          });
        } else {
          if (type == 'research_document') {
            this.researchData.bookmarked = false
          } else if (type == 'market_data') {
            data.bookmarked = false;
          }
          swal({
            position: "center",
            type: "success",
            title: "Removed from the bookmarks list",
            showConfirmButton: false,
            timer: 1000
            // text: "Bookmarked"
          });
        }

      },
      error => {

      }
    );
  }
  viewIndex() {
    this.rolesSharedService.getViewIndex(this.researchId).subscribe(
    (response: any) => {
      response.forEach((indexObj) => {
        indexObj.marketDataDetails = _.sortBy(indexObj.marketDataDetails, ['order']);       
      })
   this.viewindex = response;
  },
  error => {}
);
}
  surveyQuestionnaireNavigation() {
    this.showModal()
  }

  researchDetailViewNavigation() {
    //this.dataService.researchDocumentDataService(this.researchData);
    this.breadcrumService.setUrl('BC4Label', 'View Details');
    if (this.userRole === 'tech-vendor') {
      this.router.navigate([`${this.userRole}/market-data-detail/${this.researchId}`]);
    } else {
      this.router.navigate([`${this.userRole}/research-detail/${this.researchId}`]);
    }
  }

  routeMarketDataDetails(marketData: any) {
    this.marketDataDetailsService.marketData(marketData);
    this.router.navigate([`${this.userRole}/market-data-details/${this.researchId}/${marketData.id}`]);
  }

  subscriptionRoute(techDomainId: string) {
   this.router.navigate([`${this.userRole}/subscriptions`], { queryParams: { domain: techDomainId} });
  }

  purchaseModal() {
    this.checkoutModalDetails.showModal(this.entityType, this.researchId);
  }
  refreshAPI() {
    this.checkoutModalDetails.hideModal();
    this.getResearchData(this.researchId);
    swal("Success", 'Research purchased successfully', "success");
  }

  shareChart(index, type, researchData) {
    this.chartChildrenArray = this.chartChildren.toArray();
    this.chartChildrenArray[index].getChartBase64().then(base64 => {
      let data = {
        postType: 'research_document',
        postId: researchData.id? researchData.id : '',
        image: base64
      }
      this.socialShareService.saveSocialShare(data).subscribe(response => {
        this.linkShare.showModal(type, researchData, response['id']);
      });
    }).catch(err => {})
  }

  checkAlreadyPaid() {
    const isCompletedPayment = this.rolesSharedService.getPaymentState();
    if (isCompletedPayment && this.userRole == 'tech-vendor' && this.researchData && this.researchData.isSubscribed === false && this.researchData.isPurchased === false && this.researchData.paid) {
      this.rolesSharedService.setPaymentSate(false);
      this.purchaseModal();
    }
  }

  openLikeModal(data) {
    if (this.loggedInStatus) {
      this.likeModalService.modalStatus(true, data);
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/research-snapshot/research-snapshot.component.ts